'use client'

import { useRouter } from 'next/navigation'
import { SignOutIcon } from '@phosphor-icons/react'
import { createClient } from './supabase'
import { getEnvironmentStorageKey } from '@/lib/environment'

export function SignOutButton() {
  const router = useRouter()

  const handleSignOut = async () => {
    localStorage.removeItem(getEnvironmentStorageKey('automerge-doc-url'))
    const supabase = createClient()
    await supabase.auth.signOut()
    router.push('/auth/login')
  }

  return (
    <button
      type="button"
      onClick={handleSignOut}
      className="text-destructive hover:bg-destructive/10 flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors"
    >
      <SignOutIcon className="h-4 w-4 shrink-0" weight="regular" />
      Sign out
    </button>
  )
}
